var map = {
	"./barn_owl_hoot.mp3": 4156,
	"./eagle_owl_hoot.mp3": 4157,
	"./elf_owl_hoot.mp3": 4158,
	"./horned_owl_hoot.mp3": 4159,
	"./screech_owl_hoot.mp3": 4160,
	"./snowy_owl_hoot.mp3": 4161
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 713;



//////////////////
// WEBPACK FOOTER
// ./assets/sounds/owl-hoots .\.mp3*
// module id = 713
// module chunks = 0